import module from 'finanzas/module.js'

const schema = {
  Fecha: 'date',
  Compra: 'number',
  Venta: 'number',
  Compra_Operativa: 'number',
  Venta_Operativa: 'number',
}

function FinanzasDivisasService ($api, $schema) {
  var FinanzasDivisas = {}

  FinanzasDivisas.select = function (periodo, moneda) {
    return $api.post('kendu/finanzas/divisas/select', {
      periodo: periodo.toYMD(),
      moneda: moneda,
    }).then(function (list) {
      return list.map(function (item) {
        return Format(item)
      })
    })
  }

  FinanzasDivisas.set = function (data) {
    return $api.post('kendu/finanzas/divisas/set', {
      data: Format(data, true),
    })
  }

  function Format (data, stringify) {
    return $schema(data, schema, stringify)
  }

  return FinanzasDivisas
}

module.service('FinanzasDivisas', FinanzasDivisasService)



// WEBPACK FOOTER //
// ./src/finanzas/services/FinanzasDivisas.js